module.exports = __webpack_public_path__ + "assets/fox500_dark.png";